import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ArrayMinSize,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour créer une adhésion d'établissement
 */
export class CreateEstablishmentMembershipDto {
  @ApiProperty({ type: 'string', description: 'ID établissement' })
  @IsNotEmpty()
  @IsUUID('4')
  establishmentId!: string

  @ApiProperty({ type: 'string', description: 'ID utilisateur' })
  @IsNotEmpty()
  @IsString()
  userId!: string

  @ApiProperty({ type: 'string', description: 'ID rôle' })
  @IsNotEmpty()
  @IsUUID('4')
  roleId!: string

  @ApiPropertyOptional({ type: 'string', description: "Date d'adhésion" })
  @IsOptional()
  @IsDateString()
  joinedAt?: string

  @ApiPropertyOptional({ type: 'string', description: 'Date de départ' })
  @IsOptional()
  @IsDateString()
  leftAt?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Actif', default: true })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean
}

/**
 * DTO pour modifier une adhésion d'établissement
 */
export class UpdateEstablishmentMembershipDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID établissement' })
  @IsOptional()
  @IsString()
  establishmentId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID utilisateur' })
  @IsOptional()
  @IsString()
  userId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID rôle' })
  @IsOptional()
  @IsUUID('4')
  roleId?: string

  @ApiPropertyOptional({ type: 'string', description: "Date d'adhésion" })
  @IsOptional()
  @IsDateString()
  joinedAt?: string

  @ApiPropertyOptional({ type: 'string', description: 'Date de départ' })
  @IsOptional()
  @IsDateString()
  leftAt?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Actif' })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean
}

/**
 * DTO pour ajouter plusieurs membres à un établissement (bulk)
 */
export class AddEstablishmentMembersDto {
  @ApiProperty({
    description: 'IDs des utilisateurs à ajouter à l\'établissement',
    type: [String],
    example: ['user-1', 'user-2', 'user-3'],
  })
  @IsArray()
  @ArrayMinSize(1, { message: 'Au moins un utilisateur doit être spécifié' })
  @IsString({ each: true })
  userIds!: string[]

  @ApiProperty({ type: 'string', description: 'ID rôle commun pour tous les membres' })
  @IsNotEmpty()
  @IsUUID('4')
  roleId!: string

  @ApiPropertyOptional({
    type: 'string',
    description: "Date d'adhésion (par défaut: maintenant)",
    example: '2024-01-15T08:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  joinedAt?: string
}
